<template>
  <div class="container">
    <!-- 语言切换按钮 -->
    <div class="lang-switcher">
      <a
        href="/PrivacyPolicy.html"
        target="_blank"
        rel="noopener noreferrer"
        class="privacy-policy"
        >{{ currentText.PrivacyPolicy }}</a
      >
      <a
        href="/UserAgreement.html"
        target="_blank"
        rel="noopener noreferrer"
        class="privacy-policy"
        >{{ currentText.UserAgreement }}</a
      >

      <div class="lang-selector" @click="toggleLangDropdown">
        <span class="lang-current"> {{ langLabels[currentLang] }}</span>
        <span class="lang-arrow" :class="{ active: showLangDropdown }"></span>
      </div>
      <div class="lang-dropdown" v-show="showLangDropdown">
        <div
          v-for="(label, key) in langLabels"
          :key="key"
          class="lang-option"
          :class="{ active: currentLang === key }"
          @click="selectLang(key)"
        >
          {{ label }}
        </div>
      </div>
    </div>

    <swiper :options="swiperOption" ref="mySwiper" class="swipper-content">
      <swiper-slide class="swiper-slide">
        <img src="../assets/image/logo.png" class="logo-wrapper1" />
        <div class="first-page-wrapper">
          <div class="animation-logo-wrapper" ref="lottieContainer"></div>
          <img
            class="slogon-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/slogon-en.webp')
                : require('../assets/image/slogon.webp')
            "
          />
          <div class="number-wrapper">
            <div class="bumber-text">{{ currentText.Live }}</div>
            <div class="number-point"></div>
            <div class="number-text">{{ currentText.Chat }}</div>
            <div class="number-point"></div>
            <div class="number-text">{{ currentText.Friends }}</div>
          </div>
          <img
            class="more-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/slide_more-en.webp')
                : require('../assets/image/slide_more.png')
            "
          />
          <img
            class="charge-img"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/fast_charge-en.webp')
                : require('../assets/image/fast_charge.webp')
            "
            @click="goCharge()"
          />
          <swiper
            :options="swiperOption2"
            ref="mySwiper2"
            class="swipper-content2"
          >
            <swiper-slide
              v-for="(item, index) in swiperList"
              :key="index"
              class="swiper-slide2"
            >
              <img :src="item.image" class="swiper-bottom-wrapper" />
            </swiper-slide>
          </swiper>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="second-page-wrapper">
          <img class="logo-wrapper" src="../assets/image/meoo_logo.webp" />
          <img
            class="pic-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/meiyan-en.webp')
                : require('../assets/image/meiyan.webp')
            "
          />
          <img
            class="beauty-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/beauty_bg-en.webp')
                : require('../assets/image/beauty_bg.png')
            "
          />
        </div>
      </swiper-slide>

      <swiper-slide class="swiper-slide">
        <div class="four-page-wrapper">
          <img class="logo-wrapper" src="../assets/image/meoo_logo.webp" />
          <img
            class="pic-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/liwu-en.webp')
                : require('../assets/image/liwu.webp')
            "
          />
          <img
            class="beauty-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/send_gift-en.webp')
                : require('../assets/image/send_gift.png')
            "
          />
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="five-page-wrapper">
          <img
            class="five-wrapper"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/baiwan-en.webp')
                : require('../assets/image/baiwan.webp')
            "
          />
          <div class="join-wrapper"></div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="six-page-wrapper">
          <img
            class="pic-wrapper2"
            :src="
              currentLang == 'en'
                ? require('../assets/image/en/zuihou-en.webp')
                : require('../assets/image/zuihou.webp')
            "
          />
          <div class="right-wrapper">
            <img
              class="slogon2-wrapper"
              :src="
                currentLang == 'en'
                  ? require('../assets/image/en/title-en.webp')
                  : require('../assets/image/title.webp')
              "
            />

            <div class="down-wrapper">
              <!-- <div class="down-left">
                <img class="qrcode" src="../assets/image/qrcode.webp" />
                <div class="text">{{ currentText.scanQr }}</div>
              </div> -->
              <div class="button-wrapper">
                <img
                  class="button-top"
                  :src="
                    currentLang == 'en'
                      ? require('../assets/image/en/appstore-en.webp')
                      : require('../assets/image/appstore.png')
                  "
                  @click="redirectToAppStore()"
                />
                <img
                  class="button-bottom"
                  src="../assets/image/googleplay.png"
                  @click="redirectToGooglePlay()"
                />
              </div>
            </div>
          </div>
          <div class="name-wrapper3"></div>
        </div>
      </swiper-slide>
      <!-- 聯絡我們 -->
      <swiper-slide class="swiper-slide">
        <div class="lianxi-wrapper">
          <!-- <div class="title">{{ currentText.contactUs }}</div> -->
          <img class="name-img" src="../assets/image/name.png" />

          <div class="form">
            <el-form
              label-position="top"
              :model="formLabelAlign"
              label-width="100px"
              :rules="currentRules"
              ref="formLabelAlign"
            >
              <el-form-item :label="currentText.formName" prop="name">
                <el-input
                  v-model="formLabelAlign.name"
                  :placeholder="currentText.placeholderName"
                ></el-input>
              </el-form-item>
              <el-form-item :label="currentText.formEmail" prop="email">
                <el-input
                  v-model="formLabelAlign.email"
                  :placeholder="currentText.placeholderEmail"
                ></el-input>
              </el-form-item>
              <el-form-item :label="currentText.formContactType" prop="type">
                <el-select
                  v-model="formLabelAlign.type"
                  :placeholder="currentText.placeholderContactType"
                >
                  <el-option label="Whatsapp" value="Whatsapp"></el-option>
                  <el-option label="WeChat" value="WeChat"></el-option>
                  <el-option label="Line" value="Line"></el-option>
                  <el-option label="Telegram" value="Telegram"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="number">
                <el-input
                  v-model="formLabelAlign.number"
                  :placeholder="currentText.placeholderContactAccount"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="currentText.formContactReason"
                prop="region"
              >
                <el-select
                  v-model="formLabelAlign.region"
                  :placeholder="currentText.placeholderContactReason"
                >
                  <el-option
                    v-for="item in reasonOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="currentText.formMessage"
                prop="textarea"
                :class="{ 'is-max': isTextareaMax }"
              >
                <el-input
                  type="textarea"
                  :rows="9"
                  maxlength="200"
                  show-word-limit
                  v-model="formLabelAlign.textarea"
                  :placeholder="currentText.placeholderMessage"
                ></el-input>
              </el-form-item>
              <div
                class="re-btn"
                @click="submitForm('formLabelAlign')"
                :style="{ backgroundColor: buttonColor }"
              >
                {{ currentText.submitBtn }}
              </div>
            </el-form>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="tab-wrapper">
      <div class="tabs" ref="tabs">
        <div
          class="tab-item"
          v-for="(tab, index) in tabsText"
          :key="index"
          :class="{ active: index === activeIndex }"
          @click="changeSlide(index)"
        >
          {{ tab }}
          <div class="tab-indicator" v-if="index === activeIndex"></div>
        </div>
        <div class="tab-line"></div>
      </div>
    </div>
    <div v-if="isShowPop" class="join-pop" @click="showJoin()">
      <div class="pop"></div>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import QRCode from "qrcode";
import animationData from "../assets/meoo_animation.json";
import logoUrl from "../assets/meoo.png";
import { sendMessage } from "../api/app";
import { commonMakeSign, getSignKey } from "../utils/sign";
export default {
  data() {
    return {
      swiperList: [
        { image: require("@/assets/image/carousel01.webp") },
        { image: require("@/assets/image/carousel02.webp") },
        { image: require("@/assets/image/carousel03.webp") },
        { image: require("@/assets/image/carousel04.webp") },
        { image: require("@/assets/image/carousel05.webp") },
        { image: require("@/assets/image/carousel06.webp") },
      ],
      activeIndex: 0,
      qrCodeImage: "",
      isShowPop: false,
      currentLang: localStorage.getItem("lang") || "zh-TW", // 默认繁体
      showLangDropdown: false,
      langLabels: {
        "zh-TW": "繁體中文",
        en: "English",
      },
      i18n: {
        "zh-CN": {
          tabs: [
            "首页",
            "智能美颜",
            "趣味礼物",
            "合作主播",
            "下载APP",
            "联系我们",
          ],
          contactUs: "联系我们",
          //  "联系我们",
          formName: "您的姓名",
          formEmail: "您的邮箱",
          formContactType: "常用联络方式",
          formContactReason: "联络类型",
          formMessage: "留言",
          placeholderName: "请输入您的姓名",
          placeholderEmail: "请输入您的邮箱",
          placeholderContactType: "请选择联络方式",
          placeholderContactAccount: "请输入所选联络方式账号",
          placeholderContactReason: "请选择联络类型",
          placeholderMessage: "请输入留言",
          submitBtn: "提交",
          reasonOptions: [
            { label: "公会入驻", value: "region1" },
            { label: "币商咨询", value: "region2" },
            { label: "主播开播", value: "region3" },
            { label: "意见反馈", value: "region4" },
            { label: "其他", value: "region5" },
          ],
          validationMessages: {
            nameRequired: "请输入您的姓名",
            nameNoSpaces: "名称不可全为空格",
            emailRequired: "请输入您的邮箱",
            emailFormat: "请输入正确的邮箱格式",
            typeRequired: "请选择联络方式",
            numberRequired: "请输入所选联络方式账号",
            regionRequired: "请选择联络类型",
          },
          scanQr: "扫描二维码下载",
          Live: "直播",
          Chat: "聊天",
          Friends: "交友",
          PrivacyPolicy: "隐私政策",
          UserAgreement: "用户协议",
        },
        "zh-TW": {
          tabs: [
            "首頁",
            "智能美顏",
            "趣味禮物",
            "合作主播",
            "下載APP",
            "聯絡我們",
          ],
          //  ,
          contactUs: "聯絡我們",
          formName: "您的姓名",
          formEmail: "您的郵箱",
          formContactType: "常用聯絡方式",
          formContactReason: "聯絡型別",
          formMessage: "留言",
          placeholderName: "請輸入您的姓名",
          placeholderEmail: "請輸入您的郵箱",
          placeholderContactType: "請選擇聯絡方式",
          placeholderContactAccount: "請輸入所選聯絡方式賬號",
          placeholderContactReason: "請選擇聯絡型別",
          placeholderMessage: "請輸入留言",
          submitBtn: "提交",
          reasonOptions: [
            { label: "公會入駐", value: "region1" },
            { label: "幣商咨詢", value: "region2" },
            { label: "主播開播", value: "region3" },
            { label: "意見反饋", value: "region4" },
            { label: "其他", value: "region5" },
          ],
          validationMessages: {
            nameRequired: "請輸入您的姓名",
            nameNoSpaces: "名稱不可全為空格",
            emailRequired: "請輸入您的郵箱",
            emailFormat: "請輸入正確的郵箱格式",
            typeRequired: "請選擇聯絡方式",
            numberRequired: "請輸入所選聯絡方式賬號",
            regionRequired: "請選擇聯絡型別",
          },
          scanQr: "掃描二維碼下載",
          Live: "直播",
          Chat: "聊天",
          Friends: "交友",
          PrivacyPolicy: "隱私政策",
          UserAgreement: "用戶協議",
        },
        en: {
          tabs: [
            "Home",
            "Smart Beauty",
            "Fun Gifts",
            "Collaborative Hosts",
            "Download",
            "Contact Us",
          ],
          // ,
          contactUs: "Contact Us",
          formName: "Your Name",
          formEmail: "Your Email",
          formContactType: "Contact Method",
          formContactReason: "Contact Type",
          formMessage: "Message",
          placeholderName: "Please enter your name",
          placeholderEmail: "Please enter your email",
          placeholderContactType: "Select contact method",
          placeholderContactAccount: "Please enter your account",
          placeholderContactReason: "Select contact type",
          placeholderMessage: "Please enter your message",
          submitBtn: "Submit",
          reasonOptions: [
            { label: "Guild Recruitment", value: "region1" },
            { label: "Coin Merchant Inquiry", value: "region2" },
            { label: "Host Application", value: "region3" },
            { label: "Feedback", value: "region4" },
            { label: "Others", value: "region5" },
          ],
          validationMessages: {
            nameRequired: "Please enter your name",
            nameNoSpaces: "Name cannot be all spaces",
            emailRequired: "Please enter your email",
            emailFormat: "Please enter valid email",
            typeRequired: "Please select contact method",
            numberRequired: "Please enter your account",
            regionRequired: "Please select contact type",
          },
          scanQr: "Scan QR code to download",
          Live: "Live",
          Chat: "Chat",
          Friends: "Friends",
          PrivacyPolicy: "Privacy Policy",
          UserAgreement: "User Agreement",
        },
      },
      swiperOption: {
        slidesPerView: "auto",
        direction: "vertical",
        normalizeSlideIndex: false,
        on: {
          slideChange: () => {
            this.activeIndex = this.$refs.mySwiper.swiper.activeIndex;
            this.$nextTick(() => {
              const tabElement =
                this.$refs.tabs.getElementsByClassName("tab-item")[
                  this.activeIndex
                ];
              tabElement.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start",
              });
            });
          },
        },
      },
      swiperOption2: {
        slidesPerView: "auto",
        spaceBetween: 10,
        normalizeSlideIndex: false,
        loop: true,
      },
      formLabelAlign: {
        name: "",
        email: "",
        number: "",
        region: "",
        type: "",
        textarea: "",
      },
    };
  },
  computed: {
    currentText() {
      return this.i18n[this.currentLang];
    },
    tabsText() {
      return this.currentText.tabs;
    },
    reasonOptions() {
      return this.currentText.reasonOptions;
    },

    currentRules() {
      const messages = this.currentText.validationMessages;
      return {
        name: [
          { required: true, message: messages.nameRequired, trigger: "blur" },
          {
            validator: (_rule, value, callback) => {
              if (value && value.trim() === "") {
                callback(new Error(messages.nameNoSpaces));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: messages.emailRequired, trigger: "blur" },
          { type: "email", message: messages.emailFormat, trigger: "blur" },
        ],
        type: [
          { required: true, message: messages.typeRequired, trigger: "change" },
        ],
        number: [
          { required: true, message: messages.numberRequired, trigger: "blur" },
        ],
        region: [
          {
            required: true,
            message: messages.regionRequired,
            trigger: "change",
          },
        ],
      };
    },
    isTextareaMax() {
      return this.formLabelAlign.textarea.length >= 200;
    },
    buttonColor() {
      const { name, email, number, region, type, textarea } =
        this.formLabelAlign;
      const allFilled = [name, email, number, region, type, textarea].every(
        (field) => field && field.trim() !== "",
      );
      return allFilled ? "#984afe" : "#c489fe";
    },
  },
  created() {
    window.document.title = "Meoo Live";
  },
  mounted() {
    this.loadAnimation();
    this.generateQRCodeWithLogo();
    window.addEventListener("wheel", (event) => {
      if (event.deltaY > 0) {
        if (this.activeIndex < 5) {
          this.changeSlide(this.activeIndex + 1);
        }
      } else {
        if (this.activeIndex > 0) {
          this.changeSlide(this.activeIndex - 1);
        }
      }
    });
  },
  methods: {
    changeLanguage() {
      // 切换语言时重新生成校验规则（已通过computed自动更新）
      this.$nextTick(() => {
        if (this.$refs.formLabelAlign) {
          this.$refs.formLabelAlign.clearValidate();
        }
      });
    },
    toggleLangDropdown() {
      this.showLangDropdown = !this.showLangDropdown;
    },
    selectLang(lang) {
      this.currentLang = lang;
      localStorage.setItem("lang", lang);
      this.showLangDropdown = false;
      this.changeLanguage();
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate().catch(() => false);
      if (!valid) {
        return false;
      }
      try {
        // 联络方式类型映射：Whatsapp=1, WeChat=2, Line=3, Telegram=4
        const contactTypeMap = { Whatsapp: 1, WeChat: 2, Line: 3, Telegram: 4 };
        // 联络类型映射：region1=1, region2=2, ..., region5=5
        const businessTypeMap = {
          region1: 1,
          region2: 2,
          region3: 3,
          region4: 4,
          region5: 5,
        };

        const timestamp = Math.floor(Date.now() / 1000);
        const requestData = {
          name: this.formLabelAlign.name,
          email: this.formLabelAlign.email,
          contact_type: contactTypeMap[this.formLabelAlign.type] || 0,
          contact_value: this.formLabelAlign.number,
          business_type: businessTypeMap[this.formLabelAlign.region] || 0,
          message: this.formLabelAlign.textarea,
          _ts: timestamp,
        };

        // 生成签名
        const sign = await commonMakeSign(requestData, getSignKey());
        requestData.sign = sign;

        const res = await sendMessage(requestData);
        if (res && res.data && res.data.code == 200) {
          // 根据实际接口返回结构判断
          this.$message.success(
            this.currentLang === "en"
              ? "Submitted successfully!"
              : "提交成功！",
          );
          this.$refs[formName].resetFields();
        } else {
          this.$message.error(res.data.message);
        }
      } catch (error) {
        console.error("submitForm error:", error);
        this.$message.error(
          this.currentLang === "en"
            ? "Submission failed, please try again later"
            : "提交失败，请稍后再试",
        );
      }
    },
    changeSlide(index) {
      this.activeIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index);
    },
    goCharge() {
      window.location.href = "https://webpay.meoo.live/";
    },
    loadAnimation() {
      const animation = lottie.loadAnimation({
        container: this.$refs.lottieContainer,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData,
      });
      animation.setSpeed(0.7);
    },
    redirectToAppStore() {
      window.location.href = "https://apps.apple.com/app/meoo/id6471481453";
    },
    redirectToGooglePlay() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.ufun.livestreaming";
    },
    showJoin() {
      this.isShowPop = !this.isShowPop;
    },
    async generateQRCodeWithLogo() {
      const qrCodeData = "https://mycdn02.tianzhuwoye.com/meoo.apk";
      const canvas = document.createElement("canvas");
      await QRCode.toCanvas(canvas, qrCodeData, {
        errorCorrectionLevel: "H",
        margin: 1,
        borderRadius: 10,
      });
      const ctx = canvas.getContext("2d");
      const logo = new Image();
      logo.src = logoUrl;
      logo.onload = () => {
        const logoSize = canvas.width * 0.2;
        const x = (canvas.width - logoSize) / 2;
        const y = (canvas.height - logoSize) / 2;
        ctx.drawImage(logo, x, y, logoSize, logoSize);
        this.qrCodeImage = canvas.toDataURL();
      };
    },
  },
};
</script>

<style lang="less">
html,
body,
#app,
#app > div {
  width: 100%;
  height: 100% !important;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  width: 100%;
  height: 100%;
}

/* 语言切换样式 */
.lang-switcher {
  position: fixed;
  top: 50px;
  right: 250px;
  z-index: 100;
  display: flex;
  align-items: center;

  .privacy-policy {
    color: #fff;
    font-size: 0.085rem;
    text-decoration: underline;
    margin-right: 15px;
  }
  .lang-selector {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    padding: 8px 16px;
    backdrop-filter: blur(5px);
    cursor: pointer;
    transition: background 0.3s;
    &:hover {
      background: rgba(0, 0, 0, 0.8);
    }
    .lang-current {
      color: #fff;
      font-size: 14px;
    }
    .lang-arrow {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid #fff;
      transition: transform 0.3s;
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .lang-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: rgba(0, 0, 0, 0.9);
    border-radius: 12px;
    overflow: hidden;
    backdrop-filter: blur(10px);
    min-width: 120px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    .lang-option {
      padding: 10px 16px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        background: rgba(152, 74, 254, 0.5);
        color: #fff;
      }
      &.active {
        background: rgba(152, 74, 254, 0.7);
        color: #fff;
      }
    }
  }
}

.tab-wrapper {
  position: fixed;
  top: 30.6vh; /* 距离屏幕顶部2/3位置 */
  right: 60px;
  width: 8vw;
  z-index: 10;
}

.charge-img {
  position: absolute;
  right: 50px;
  top: 50px;
  width: 16vh;
  height: auto;
  cursor: pointer;
  animation: zoomInOut 1s infinite;
}
@keyframes zoomInOut {
  0%,
  100% {
    transform: scale(1); /* 原始大小 */
  }
  50% {
    transform: scale(1.1); /* 放大到1.5倍 */
  }
}
.tabs {
  width: 8vw;
  position: relative;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
}

.tabs ::-webkit-scrollbar {
  display: none;
}

.tabs .tab-item {
  padding: 1vh;
  cursor: pointer;
  position: relative;
  margin: 0 5px;
  font-weight: 400;
  font-size: 0.1rem;
  color: rgba(255, 255, 255, 0.4);
}

.tab-line {
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 30vh;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    #ffffff 49%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 0px 0px 0px 0px;
}

.tab-indicator {
  position: absolute;
  width: 10px;
  height: 10px;
  background-image: url("../assets/image/dot.png");
  background-size: cover;
  background-repeat: no-repeat;
  top: 50%;
  transform: translateY(-50%);
  right: -9px; /* 调整圆圈位置 */
}

.tabs .active {
  font-size: 0.12rem;
  color: #ffffff;
  bottom: 6px;
}
.swipper-content {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 1;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #000;
  width: 100% !important;
}

.first-page-wrapper {
  width: 100%;
  height: 100%;
  background-image: url("../assets/image/web_bg_one.webp");
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;

  .animation-logo-wrapper {
    // width: 20vw;
    height: 20vh;
    margin-top: 20vh;
  }

  .slogon-wrapper {
    // width: 25vw;
    height: 6vh;
    margin-top: -1%;
  }
  .number-wrapper {
    font-size: 0.33rem;
    margin-top: 1.5%;
    color: #fff;
    font-weight: 600;
    display: flex;
    .number-point {
      width: 0.5vw;
      height: 0.5vw;
      background: #fff;
      border-radius: 50%;
      margin: auto 1.5vw;
    }
  }

  .more-wrapper {
    // width: 6vw;
    height: 5vh;
    margin-top: 4%;
  }

  .swipper-content2 {
    position: absolute;
    bottom: 10px;
    height: 22vh;
    width: 100%;

    .swiper-slide2 {
      width: calc(100% / 5 - 100px) !important;
      height: 1000%;
      background: none;
    }

    .swiper-bottom-wrapper {
      width: 95%;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}

.second-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/pc-bg.webp");
  background-size: cover;
  display: flex;
}

.third-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/pc-bg.webp");
  background-size: cover;
  display: flex;
}

.four-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/pc-bg.webp");
  background-size: cover;
  display: flex;
}

.six-page-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/pc-bg.webp");
  background-size: cover;
  display: flex;

  .slogon2-wrapper {
    width: 50%;
    height: auto;
    margin-top: 20vh;
  }
  .down-left {
    color: #fff;
  }
  .qrcode {
    width: 100%;
    margin: 0 10px 10px 0;
  }
  .down-wrapper {
    box-sizing: border-box;
    display: flex;
    max-width: 50vw;
    max-height: 60vh;
    margin-top: 2vh;

    .qr-wrapper {
      flex: 2;
      width: 10vw;
      height: 10vw;
    }
    .button-wrapper {
      flex: 3;
      display: flex;
      flex-direction: column;
      margin-left: 30px;

      .button-top {
        width: 17vw; /* 设置图片宽度 */
        height: auto; /* 自适应高度 */
        margin-top: 6px;
      }

      .button-bottom {
        width: 17vw; /* 设置图片宽度 */
        height: auto; /* 自适应高度 */
        margin-top: 2vh;
      }
    }
  }

  .name-wrapper2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 12px;
    margin-top: 14px;
    padding-left: 15px;
    margin-bottom: 50px;
  }
}

.five-page-wrapper {
  width: 100vw;
  height: 100vh;
  // background-image: url("../assets/image/baiwan.webp");
  // background-size: cover;
  // background-position: center;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  position: relative;
  .five-wrapper {
    width: 100%;
    height: 110%;
    position: absolute;
    top: 0px;
    left: 0;
  }
  .join-wrapper {
    width: 20vw;
    height: 35vh;
  }
}

.logo-wrapper {
  position: absolute;
  width: 120px;
  // height: 220px;
  left: 70px;
  top: 70px;
}
.logo-wrapper1 {
  position: absolute;
  width: 20vh;
  // height: 220px;
  left: 70px;
  top: 70px;
}

.pic-wrapper {
  max-width: 45%;
  // max-height: 70%;
  margin-top: 5%;
  margin-left: 1%;
}

.pic-wrapper2 {
  max-width: 35%;
  max-height: 80%;
  flex-shrink: 0;
  margin-top: 5%;
  margin-left: 5%;
}

.name-wrapper {
  text-align: left;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #ffffff;
  line-height: 12px;
  margin-top: 42px;
  padding-left: 15px;
}

.right-wrapper {
  max-width: 30vw;
  max-height: 30vh;
  margin-top: 8vh;
  margin-left: 10vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.beauty-wrapper {
  max-width: 35%;
  max-height: 40%;
  margin-top: 15%;
  margin-left: 50px;
}

.name-wrapper3 {
  position: absolute;
  right: 1vw;
  bottom: 1vh;
  width: 15vw;
  height: 4vh;
  background-image: url("../assets/image/name.png");
  background-size: 100%, 100%;
  background-repeat: no-repeat;
  z-index: 20;
}

.join-pop {
  position: fixed;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居上 */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.pop {
  width: 35vw;
  height: 40vh;
  background-image: url("../assets/image/join_bg.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

// 聯絡我們
.name-img {
  height: 15px;
  position: absolute;
  right: 50px;
  top: 100px;
}
.lianxi-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url("../assets/image/pc-bg.webp");
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    font-size: 30px;
  }
  .form {
    width: 20%;
    min-width: 400px;
    margin: auto 0;
    .el-form-item__label {
      color: #fff;
      line-height: 0;
      width: 100%;
    }
    .el-form-item {
      margin-bottom: 30px;
    }
    .el-form-item__content {
      width: 100% !important;
    }
    .el-select {
      text-align: left !important;
      width: 100%;
      position: relative;
    }

    .el-form-item__error {
      color: #ff4d4f;
      position: absolute;
      right: -50%;
      top: 30%;
      pointer-events: none;
    }
    .re-btn {
      width: 50%;
      height: 40px;
      border-radius: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 15px;
      // background-color: #984afe;
      background-color: #c489fe;
      margin: 0 auto;
      cursor: pointer;
      &:hover {
        background-color: #984afe;
      }
    }
    .is-max .el-input__count {
      color: #ff4d4f !important;
    }
  }
}
</style>
